import { Port } from '@navstation-portal/ports/data-model/ports';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { PORTS_STORE_ID } from './constants';

export const portEvents = eventGroup({
  source: PORTS_STORE_ID,
  events: {
    fetchPorts: type<void>(),
    fetchPortsSuccess: type<Port[]>(),
    fetchPortsFailed: type<Error>(),
    clearPorts: type<void>(),
  },
});
